var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveViewerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2213 6.05401C10.2213 7.29348 9.21646 8.29828 7.97699 8.29828C6.73751 8.29828 5.73272 7.29348 5.73272 6.05401C5.73272 4.81453 6.73751 3.80974 7.97699 3.80974C9.21646 3.80974 10.2213 4.81453 10.2213 6.05401Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3789 5.71945C13.7644 2.49037 10.8969 0.817383 7.97699 0.817383C5.0571 0.817383 2.18961 2.49037 0.575072 5.71945C0.469768 5.93006 0.469768 6.17796 0.575072 6.38856C2.18961 9.61765 5.0571 11.2906 7.97699 11.2906C10.8969 11.2906 13.7644 9.61765 15.3789 6.38856C15.4842 6.17796 15.4842 5.93006 15.3789 5.71945ZM7.97699 9.79445C5.75607 9.79445 3.487 8.58196 2.08927 6.05401C3.487 3.52605 5.75607 2.31356 7.97699 2.31356C10.1979 2.31356 12.467 3.52605 13.8647 6.05401C12.467 8.58196 10.1979 9.79445 7.97699 9.79445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveViewerIcon);
export default __webpack_public_path__ + "static/media/live-viewer-icon.ec4c741dcac7ff2731b9f71c331d05d3.svg";
export { ForwardRef as ReactComponent };